import axios from "axios";
import UnauthorizedError from "../UnauthorizedError"

export const DATA_HAS_BEEN_CHANGED_ERROR = 428;

// Links API実行
export const executeLinksAPI = (path, config) => {
    const apiUrl = process.env.REACT_APP_APP_FOSTERLINKS_ADDIN_API_URL;
    const apiKey = process.env.REACT_APP_APP_FOSTERLINKS_ADDIN_API_KEY;

    const base = {
        url: `${apiUrl}/${path}`,
        headers: { 
            'x-api-key': apiKey
        },
        withCredentials: true,
        validateStatus: status => (status >= 200 && status < 300) || status === 401
    };
    const _config = {
        ...config,
        ...base
    };

    return axios(_config)
        .then(res => {
            // 認証エラー(HTTPステータス401)の場合は専用のErrorをthrowする
            if (res.status === 401) {
                throw new UnauthorizedError('Unauthorized');
            }
            return res.data;
        }).catch(e => {
            throw e;
        });
};
